module.exports = __webpack_public_path__ + "img/apple-2.ca60a871.png";